import React from 'react'

function onSubmit(event) {
  event.preventDefault();

  const a = document.createElement("a");
  a.href = "11102080.pdf";
  a.download = "11102080.pdf";

  // Trigger the click event to start the download
  a.click();
}
  
  function DownloadForm() {
      return (
          <form onSubmit={onSubmit}>
              <label htmlFor="email">Enter your email:</label>
              <input type="email" id="email" name="email" required />
              <button type="submit">Submit</button>
          </form>
      );
  }

const Formpdf = () => {
  return (
    <div>
      <h1>Download My Resume</h1>
      <DownloadForm />
      </div>
  )
}

export default Formpdf